// Exit intent detection — Shopify pattern
// Detects when user is about to leave (mouse to top, tab switch, back button)
import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/analytics";

export function useExitIntent(): void {
  const firedRef = useRef(false);

  useEffect(() => {
    const fireExitIntent = (trigger: string) => {
      if (firedRef.current) return;
      firedRef.current = true;

      trackEvent("exit_intent", {
        trigger,
        page_url: window.location.pathname,
        time_on_site_ms: Math.round(performance.now()),
      });
    };

    // Desktop: mouse leaves viewport from top
    const onMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 20) {
        fireExitIntent("mouse_leave_top");
      }
    };

    // Tab switch / app backgrounding
    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        fireExitIntent("tab_switch");
      }
    };

    // Back button (popstate)
    const onPopState = () => {
      fireExitIntent("back_navigation");
    };

    document.addEventListener("mouseleave", onMouseLeave);
    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("popstate", onPopState);

    return () => {
      document.removeEventListener("mouseleave", onMouseLeave);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("popstate", onPopState);
    };
  }, []);
}
